// extracted by mini-css-extract-plugin
module.exports = {"container":"divider_container__Rp4Wu","primary":"divider_primary__xgIAO","gray":"divider_gray__KIQCm","pink":"divider_pink__w7dsP"};